<template>
    <div class="deep-wrap section-wrap">
        <div class="left">
            <template v-for="(vv,kk) in cal_deep">
                <div class="collapse-title" @click="toggle_panel(kk)">{{kk}}</div>
                <div class="collapse-content" v-show="show_arr[kk]">
                    <div class="list" v-for="(item,index) in vv" :key="`d`+kk+index" @click="open_right(item, 3)">
                        <div class="item">
                            <span class="name">{{ item.deep_name }}</span>
                            <span class="value">
                            <template v-if="item.deep_key.startsWith('WA')">{{ zs_buwei_list.map(v=>v.text).join(',') }}</template>
                            <template v-else-if="item.deep_key.startsWith('WC')">{{ form_data.pj_buwei_list[item.deep_key]? form_data.pj_buwei_list[item.deep_key].text : '' }}</template>
                            <template v-else-if="item.deep_key.startsWith('WB')">{{ form_data.zs_fabric_key }}</template>
                            <template v-else-if="item.deep_key.startsWith('WD')">{{ form_data.pj_fabric_key }}</template>
                            <template v-else-if="item.deep_key.startsWith('XA')">{{ tj_buwei_list.map(v=>v.text).join(',') }}</template>
                            <template v-else>{{deep_list[item.deep_key]}}</template>
                        </span>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <div class="right">
            <div class="cate-box">
                <template v-if="show_item.deep_key.startsWith('WC')">
                    <div class="cate" v-for="oItem in show_item.option_list" @click="choose_pj(show_item.deep_key, oItem)"
                         :class="{'cate-active':pj_buwei_list[show_item.deep_key] && pj_buwei_list[show_item.deep_key].text ==oItem.text,'select-active':pj_buwei_list[show_item.deep_key] && pj_buwei_list[show_item.deep_key].text ==oItem.text}"
                    >
                        <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                        <img class="img"
                             v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                        <div class="name"> {{ oItem.text }}</div>
                    </div>
                </template>
                <template v-else-if="show_item.deep_key.startsWith('WA')">
                    <div class="cate" v-for="oItem in show_item.option_list" @click="choose_zs(oItem)"
                         :class="{'cate-active':zs_buwei_list.map(v=>v.text).includes(oItem.text),'select-active':zs_buwei_list.map(v=>v.text).includes(oItem.text)}">
                        <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                        <img class="img"
                             v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                        <div class="name"> {{ oItem.text }}</div>
                    </div>
                </template>
                <template v-else-if="show_item.deep_key.startsWith('WB')">
                    <div class="cate" v-for="oItem in show_item.option_list"
                         @click="choose_zs_fabric_key(show_item.deep_key, show_item.deep_name,oItem.text,oItem.fabric_key, oItem.material, oItem.color)"
                         :class="{'cate-active':form_data.zs_fabric_key===oItem.fabric_key,'select-active':form_data.zs_fabric_key===oItem.fabric_key}">
                        <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                        <img class="img"
                             v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                        <div class="name"> {{ oItem.text }}</div>
                    </div>
                    <div class="color-list">
                        <div class="color-item" v-for="(vc, kc) in accessory_color_map[accessory_key2option_map[show_item.deep_key]]" :key="`ffcc`+kc" @click="choose_zs_common_color(vc, show_item)">
                            <div class="item-wrap">
                                <img :src="vc.color_value" alt="" class="color-image" />
                                <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="accessory_option2color_map[accessory_key2option_map[show_item.deep_key]]===vc.color_key"  />
                                <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                            </div>
                            <p class="color-name">{{vc.color_name_cn}}</p>
                        </div>
                    </div>
                </template>
                <template v-else-if="show_item.deep_key.startsWith('WD')">
                    <div class="cate" v-for="oItem in show_item.option_list"
                         @click="choose_pj_fabric_key(show_item.deep_key, show_item.deep_name,oItem.text,oItem.fabric_key, oItem.material, oItem.color)"
                         :class="{'cate-active':form_data.pj_fabric_key===oItem.fabric_key,'select-active':form_data.pj_fabric_key===oItem.fabric_key}">
                        <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                        <img class="img"
                             v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                        <div class="name"> {{ oItem.text }}</div>
                    </div>
                    <div class="color-list">
                        <div class="color-item" v-for="(vc, kc) in accessory_color_map[accessory_key2option_map[show_item.deep_key]]" :key="`ffcc`+kc" @click="choose_pj_common_color(vc, show_item)">
                            <div class="item-wrap">
                                <img :src="vc.color_value" alt="" class="color-image" />
                                <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="accessory_option2color_map[accessory_key2option_map[show_item.deep_key]]===vc.color_key"  />
                                <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                            </div>
                            <p class="color-name">{{vc.color_name_cn}}</p>
                        </div>
                    </div>
                </template>
                <template v-else-if="show_item.deep_key.startsWith('XA')">
                    <div class="cate" v-for="oItem in show_item.option_list" @click="choose_tj(oItem)"
                         :class="{'cate-active':tj_buwei_list.map(v=>v.text).includes(oItem.text),'select-active':tj_buwei_list.map(v=>v.text).includes(oItem.text)}">
                        <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                        <img class="img"
                             v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                        <div class="name"> {{ oItem.text }}</div>
                    </div>
                </template>
                <template v-else>
                    <div class="cate" v-for="oItem in  show_item.option_list"
                         @click="choose_deep(show_item.deep_key, show_item.deep_name, oItem.text, oItem.key)"
                         :class="{'cate-active':deep_list[show_item.deep_key]==oItem.text,'select-active':deep_list[show_item.deep_key]==oItem.text}">
                        <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(oItem.image)"/>
                        <img class="img"
                             v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"/>
                        <div class="name"> {{ oItem.text }}</div>
                    </div>
                    <div class="color-list">
                        <div class="color-item" v-for="(vc, kc) in accessory_color_map[accessory_key2option_map[show_item.deep_key]]" :key="`ac`+kc" @click="choose_deep_color(vc, show_item)">
                            <div class="item-wrap">
                                <img :src="vc.color_value" alt="" class="color-image" />
                                <img class="color-radio" src="@/assets/images/select.png" alt="" v-if="accessory_option2color_map[accessory_key2option_map[show_item.deep_key]]===vc.color_key"  />
                                <img class="color-radio" src="@/assets/images/no-select.png" alt="" v-else />
                            </div>
                            <p class="color-name">{{vc.color_name_cn}}</p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex'
    import {MAccessoryColor} from "@/api";
    export default {
        name: "Deep",
        data() {
            return {
                accessory_color_map: {},
                show_type: 1,
                show_item: {},
                show_arr: {},

                part: [],
                relate_map_part: new Map(),
                relate_map_deep: new Map(),
                interval_id: null
            }
        },
        computed: {
            ...mapState({
                part_list: (state) => state.mtm.form_data.part_list,
                deep: (state) => state.mtm.picked_category.hasOwnProperty('deep') ? state.mtm.picked_category.deep : Array.of(),
                deep_list: (state) => state.mtm.form_data.deep_list,
                pj_buwei_list: (state) => state.mtm.form_data.pj_buwei_list,
                zs_buwei_list: (state) => state.mtm.form_data.zs_buwei_list,
                tj_buwei_list: (state) => state.mtm.form_data.tj_buwei_list,
                form_data: (state) => state.mtm.form_data,
            }),
            cal_deep() {
                let result = {}
                for (let k in this.deep) {
                    if (!result.hasOwnProperty(this.deep[k].fenlei)) {
                        result[this.deep[k].fenlei] = []
                    }
                    result[this.deep[k].fenlei].push(this.deep[k])
                }
                return result
            },
            accessory_key2option_map() {
                let obj = {}
                for(let i in this.form_data.deep_code) {
                    obj[this.form_data.deep_code[i].deep_key] = this.form_data.deep_code[i].option_key
                }
                return obj
            },
            accessory_option2color_map() {
                let obj = {}
                for(let i in this.form_data.deep_code) {
                    if(this.form_data.deep_code[i].option_key) {
                        obj[this.form_data.deep_code[i].option_key] = this.form_data.deep_code[i].color_key
                    }
                }
                return obj
            },
        },
        methods: {
            toggle_panel(key) {
                this.$set(this.show_arr, key, !!!(this.show_arr[key]))
            },
            open_right(item, show_type = 1) {
                this.show_type = show_type
                this.show_item = item
            },
            mag(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
            },
            choose_deep_color(color_item, current_item) {
                this.$store.commit('mtm/choose_deep_color', {
                    color_item, deep_key: current_item.deep_key
                })
            },
            choose_deep(deep_key, deep_name, option_name, option_key) {
                this.$store.commit('mtm/choose_deep', {
                    deep_key, deep_name, option_name, option_key
                })

                if (deep_key === 'Y24') {
                }
                // 修改被影响的选项
                if (this.relate_map_deep.has(option_key)) {
                    // 每个关联显示的部位

                    for (let key_self in this.relate_map_deep.get(option_key)) {

                        // 自身配置里能显示的选项
                        let filter_option_list = this.relate_map_deep.get(option_key)[key_self]
                        // 寻找其他部位选中项可能对当前的影响
                        for (let key_another in this.deep_list) {
                            let part_another = this.deep.find(v => v.deep_key === key_another)
                            let relate_another = part_another.option_list.find(v => v.text == this.deep_list[key_another])
                            // 寻找其他部位选中项是否有relate_part对当前的影响
                            let ldd = {option_list: (relate_another && this.relate_map_deep.has(relate_another.key) && this.relate_map_deep.get(relate_another.key)[key_self] ? this.relate_map_deep.get(relate_another.key)[key_self] : [])}
                            if (ldd.option_list.length === 0) {
                                continue;
                            }
                            let sa = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.text)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            filter_option_list = filter_option_list.filter(v => intersect_keys.includes(v.text))
                            filter_option_list = [...new Map(filter_option_list.map(v => [v.text, v])).values()]
                        }


                        if ((this.deep.map(v => v.deep_key)).includes(key_self)) {
                            let idx = this.deep.findIndex((v) => {
                                return v.deep_key === key_self
                            })
                            if (idx === -1) {
                                continue;
                            }

                            // 填充计算后选项
                            this.$store.commit('mtm/update_category_option', {
                                key: 'deep',
                                index: idx,
                                option_list: filter_option_list
                            })
                            let key_self_item = this.deep.find(v => v.deep_key === key_self)
                            let first_option = filter_option_list[0]
                            this.choose_deep(key_self, key_self_item.deep_name, first_option.text, first_option.key)
                            // 统一清除关联项重新选择
                            // this.$store.commit('mtm/clear_deep', {deep_key: key_self})
                        }

                    }
                }
            },
            choose_zs(option) {
                this.$store.commit('mtm/choose_zs', {
                    option
                })
            },
            choose_zs_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_deep(deep_key, deep_name, option_name, fabric_key)
                this.$store.commit('mtm/choose_zs_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
            choose_zs_common_color(color_item, item) {
                this.$store.commit('mtm/choose_zs_common_color', {
                    deep_key: item.deep_key, color_item
                })
            },
            choose_tj(option) {
                this.$store.commit('mtm/choose_tj', {
                    option
                })
            },
            choose_pj(key, option) {
                console.log(111, key)
                this.$store.commit('mtm/choose_pj', {
                    key, option
                })
            },
            choose_pj_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_deep(deep_key, deep_name, option_name, fabric_key)
                this.$store.commit('mtm/choose_pj_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
            choose_pj_common_color(color_item, item) {
                this.$store.commit('mtm/choose_pj_common_color', {
                    deep_key: item.deep_key, color_item
                })
            },
        },
        destroyed() {
            clearInterval(this.interval_id)
        },
        mounted() {
            MAccessoryColor({id: this.$store.state.mtm.picked_category.id}).then(response => {
                this.accessory_color_map = response.data
            })

            let category = JSON.parse(localStorage.getItem('category') || '{}')
            this.part = category.part || []

            for(let j in this.part) {
                let o1 = this.part[j].option_list
                for (let k in o1) {
                    let o2 = this.part[j].option_list[k]
                    if (!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for (let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.category_key] = o3.option_list
                    }
                    this.relate_map_part.set(o2.part_key, obj)
                }
            }
            for(let j in this.deep) {
                let o1 = this.deep[j].option_list
                for (let k in o1) {
                    let o2 = this.deep[j].option_list[k]
                    if (!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for (let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.deep_key] = o3.option_list
                    }
                    this.relate_map_deep.set(o2.key, obj)
                }
            }
            this.open_right(this.deep[0])

            // 第一次进页面
            if (Object.keys(this.deep_list).length === 0) {
                for (let index_outer in this.deep) {
                    let deep_item = this.deep[index_outer]
                    if (deep_item.option_list.length > 0
                        && !deep_item.deep_key.startsWith('WA')
                        && !deep_item.deep_key.startsWith('WB')
                        && !deep_item.deep_key.startsWith('WC')
                        && !deep_item.deep_key.startsWith('WD')
                        && !deep_item.deep_key.startsWith('XA')
                        && !deep_item.deep_key.startsWith('XB')
                    ) {
                        let first_option = deep_item.option_list[0]
                        this.choose_deep(deep_item.deep_key, deep_item.deep_name, first_option.text, first_option.key)
                    }
                }
            }

            for (let k in this.cal_deep) {
                this.$set(this.show_arr, k, true)
            }

            this.interval_id = setInterval(() => {
                // return
                let deep_key_arr = this.deep.map(v => v.deep_key)
                for (let index in deep_key_arr) {
                    let key_self = deep_key_arr[index]
                    let options_arr = Array.of();
                    if(['W9K', 'WC9K'].includes(key_self)) {
                        options_arr = undefined
                    }
                    let flag = false


                    // 寻找其他部位选中项可能对当前的影响
                    for (let key_another in this.part_list) {

                        let part_another = this.part.find(v => v.category_key === key_another)

                        let relate_another = part_another.option_list.find(v => v.part_name_cn == this.part_list[key_another])
                        // 寻找其他部位选中项是否有relate_part对当前的影响
                        let ldd = {option_list: (relate_another && this.relate_map_part.has(relate_another.part_key) && this.relate_map_part.get(relate_another.part_key)[key_self] ? this.relate_map_part.get(relate_another.part_key)[key_self] : [])}
                        if (ldd.option_list.length === 0) {
                            continue;
                        }
                        if(['W9K', 'WC9K'].includes(key_self)) {
                            if(options_arr === undefined) {
                                options_arr = ldd.option_list
                            }
                            let sa = Array.from(new Set(options_arr.map(v => v.part_name_cn)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.part_name_cn)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            options_arr = options_arr.filter(v => intersect_keys.includes(v.part_name_cn))
                            // console.log(666, options_arr)
                            options_arr = [...new Map(options_arr.map(v => [v.part_name_cn, v])).values()]
                        } else {
                            let sb = Array.from(new Set(ldd.option_list));
                            // 这里是合集，不是交集
                            options_arr = [...options_arr, ...sb]
                            options_arr = Array.from(new Set(options_arr.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
                        }

                        flag = true
                    }
                    options_arr = options_arr.map(v => {
                        return {
                            text: v.part_name_cn,
                            image: v.image,
                            key: v.part_key
                        }
                    })
                    if(key_self === 'W9K') {
                        // console.log(555, options_arr)f
                    }
                    for (let key_another in this.deep_list) {
                        let part_another = this.deep.find(v => v.deep_key === key_another)
                        let relate_another = part_another.option_list.find(v => v.text == this.deep_list[key_another])
                        // 寻找其他部位选中项是否有relate_part对当前的影响
                        let ldd = {option_list: (relate_another && this.relate_map_deep.has(relate_another.key) && this.relate_map_deep.get(relate_another.key)[key_self] ? this.relate_map_deep.get(relate_another.key)[key_self] : [])}
                        if (ldd.option_list.length === 0) {
                            continue;
                        }
                        if(key_self === 'Y14K') {
                            let sb = Array.from(new Set(ldd.option_list));
                            options_arr = [...options_arr, ...sb]
                            options_arr = Array.from(new Set(options_arr.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
                        } else {
                            let sa = Array.from(new Set(options_arr.map(v => v.text)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.text)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            options_arr = options_arr.filter(v => intersect_keys.includes(v.text))
                            options_arr = [...new Map(options_arr.map(v => [v.text, v])).values()]
                        }

                    }

                    if (flag === false) {
                        continue;
                    }


                    let filter_option_list = options_arr

                    if ((this.deep.map(v => v.deep_key)).includes(key_self)) {
                        let idx = this.deep.findIndex((v) => {
                            return v.deep_key === key_self
                        })

                        // 填充计算后选项
                        this.$store.commit('mtm/update_category_option', {
                            key: 'deep',
                            index: idx,
                            option_list: filter_option_list
                        })

                        if (!((filter_option_list.map(v => v.text)).includes(this.deep_list[key_self])) && this.deep_list[key_self] !== undefined) {
                            this.$store.commit('mtm/clear_deep', {
                                deep_key: key_self
                            })
                        }

                        if (key_self.startsWith('XA')) {
                            let sa = Array.from(new Set(this.tj_buwei_list.map(v => v.text)));
                            let sb = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let diff_keys = sa.filter(x => !sb.includes(x));
                            for (let k = 0; k < diff_keys.length; k++) {
                                this.$store.commit('mtm/clear_tj', diff_keys[k])
                            }
                        }
                        if (key_self.startsWith('WA')) {
                            let sa = Array.from(new Set(this.zs_buwei_list.map(v => v.text)));
                            let sb = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let diff_keys = sa.filter(x => !sb.includes(x));
                            for (let k = 0; k < diff_keys.length; k++) {
                                this.$store.commit('mtm/clear_zs', diff_keys[k])
                            }
                        }
                    }
                }

            }, 500 * 3)
        },
    }
</script>

<style lang="scss" scoped>
    // chrome,safari浏览器滚动条适配
    ::-webkit-scrollbar {
        width: 10px;
        height: 3px;
    }

    ::-webkit-scrollbar-track {
        background: #eee;
        border-radius: 2px;
    }

    ::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #ddd
    }

    ::-webkit-scrollbar-corner {
        background: #ddd;
    }

    .section-wrap {
        .left {
            position: absolute;
            top: 0;
            left: 0;
            width: 270px;
            height: 99.5%;
            overflow-y: scroll;

            .collapse-title {
                width: 100%;
                height: 44px;
                line-height: 44px;
                background: #FAFAFA;
                text-align: left;
                font-size: 14px;
                color: #0F114A;
                padding: 0 20px;
                font-weight: bold;
                user-select: none;
            }

            .collapse-content {
                .list {
                    padding: 0 20px;

                    .item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        color: #000;
                        height: 44px;

                        .name {
                            font-size: 14px;

                            .red {
                                color: red;
                            }
                        }

                        .value {
                            font-size: 12px;
                            max-width: 50%;
                        }
                    }

                }
            }
        }

        .right {
            position: absolute;
            top: 5px;
            right: 0;
            width: 1080px;
            height: 98%;
            overflow-y: scroll;

            .cate-box {
                margin: 20px 10px;
                display: flex;
                flex-wrap: wrap;

                .radio-wrap {
                    width: 100%;
                    height: 30px;
                }

                .cate {
                    position: relative;
                    width: 200px;
                    margin: 10px 5px;
                    font-size: 15px;
                    font-weight: 400;
                    color: #666666;
                    text-align: center;
                    border-radius: 2px;
                    cursor: pointer;

                    .img {
                        width: 200px;
                        height: 200px;
                        padding: 25px;
                        border: 1px solid #DDDDDD;
                        box-sizing: border-box;
                    }

                    .magnifier {
                        position: absolute;
                        top: 150px;
                        right: 10px;
                        width: 40px;
                        height: 40px;
                        z-index: 10;
                    }

                    .name {
                        margin-top: 10px;
                    }

                    &.cate-active {
                        .img {
                            border: 1px solid #0f114a;
                        }

                        .name {
                            font-weight: bold;
                            color: #0F114A;
                        }
                    }
                }
            }



            .color-list {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                .color-item {
                    width: 80px;
                    text-align: center;
                    margin:10px 10px 0 0;
                    cursor: pointer;
                    .item-wrap{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        .color-image {
                            width: 80px;
                            height: 80px;
                            border: 0;
                            margin: 0;
                        }
                        .color-radio {
                            position: absolute;
                            top: 5px;
                            right: 5px;
                            width: 13px;
                            height: 13px;
                        }
                    }
                    .color-name {
                        font-size: 14px;
                    }
                }
            }
        }
    }

    .select-active {
        position: relative;
    }

    .select-active:after {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 20px;
        height: 20px;
        background-image: url("~@/assets/images/design/select@2x.png");
        background-size: 100%;

        content: "";
    }
</style>
